























import Vue from "vue";
import { TranslateResult } from "vue-i18n";

export default Vue.extend({
	components: {
		
	},
	props: ["successText", "hideTime"],

	data() {
		return {

		};
	},

	created(){
		
	},

	methods: {
        hideModal() {
			this.$bvModal.hide("success-modal");
            this.$emit('success-closed')
		},

        autoHide(){
            const hideTime: number = !!this.hideTime ? this.hideTime : 3000;
            setTimeout(() => { this.hideModal(); }, hideTime);
        }

	}

});
